"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setupUNSET_SERVICE_ACCOUNT = void 0;

var validator_id_1 = require("../../../validator-id");

var categories_1 = require("../../categories");

function setupUNSET_SERVICE_ACCOUNT(builder) {
  builder.validator(validator_id_1.ValidatorID.UNSET_SERVICE_ACCOUNT).category(categories_1.ValidatorCategory.RBAC).title('ServiceAccount not specified in container').description("ServiceAccounts grant Kubernetes API permissions to workloads. \nTo use a non-default ServiceAccount, the serviceAccountName field property should be set.\n\nThis validator detects when there is no ServiceAccount explicitly set on a workload.\n").affectedAllWorkloads().example("\nkind: Deployment\nspec:\n  template:\n    spec:\n    # serviceAccountName:    # field not set\n...\n").resolution("\nThis condition doesn't always indicate an error. It is a useful tool for SREs to quickly\nidentify which workloads don't have ServiceAccounts explicitly associated.\n\nThis validator is disabled by default.\n    ").externalLink('https://kubernetes.io/docs/tasks/configure-pod-container/configure-service-account/');
}

exports.setupUNSET_SERVICE_ACCOUNT = setupUNSET_SERVICE_ACCOUNT;